/**
 * AuthedImage (V1) — renders a bearer-gated media id as an <img> via a
 * fetched object URL. Broken/pending media degrades to a neutral placeholder
 * (never a broken-image glyph).
 */
import { useEffect, useState, type ImgHTMLAttributes } from "react";
import { authedMediaObjectUrl } from "./media-api.js";

export interface AuthedImageProps extends Omit<ImgHTMLAttributes<HTMLImageElement>, "src"> {
  mediaId: string;
}

export function AuthedImage({ mediaId, alt, ...rest }: AuthedImageProps) {
  const [url, setUrl] = useState<string | null>(null);

  useEffect(() => {
    let mounted = true;
    setUrl(null);
    void authedMediaObjectUrl(mediaId).then((u) => {
      if (mounted) setUrl(u);
    });
    return () => {
      mounted = false;
    };
  }, [mediaId]);

  if (!url) {
    return <div className="authed-img authed-img--pending" aria-label={alt} role="img" />;
  }
  return <img className="authed-img" src={url} alt={alt ?? ""} {...rest} />;
}
